<template>
  <div>

    <ui-modal
      :alignTop="true"
      :alignTopMargin="20"
      :removeHeader="false"
      ref="modal-container-events"
      :title="`Eventos contenedor ${containerNumber}`"
      class="modal-containers"
      size="auto"
      @close="ActionSetVisibleModalContainers(false);">

      <div class="col-lg-12">

        <data-table-containers-details v-if="events"
                                       :table_id="'track-cont-det-dtbl'"
                                       :shipping-status="shippingStatus"
                                       :data="events">
        </data-table-containers-details>

      </div>

    </ui-modal>

  </div>

</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";
import DataTableContainersDetails from "@/components/dataTables/safecube/DataTableContainersDetails.vue";

export default {
  components: { DataTableContainersDetails },
  props: {
    events: {
      type: Array
    },
    containerNumber: {
      type: String
    },
    shippingStatus: {
      type: String,
    }
  },
  data() {

    return {};

  },
  computed: {

    ...mapState(["visibleModalContainers"]),

    ...mapState(["usuarioActual"])

  },

  methods: {

    ...mapActions([
      "ActionSetVisibleModalContainers",
      "ActionSetZindexTablaModal"
    ]),

    openModal(ref) {

      this.$refs[ref].open();

      this.ActionSetZindexTablaModal(true);

    },

    closeModal(ref) {

      this.$refs[ref].close();

    }

  },

  watch: {

    async visibleModalContainers(_new) {

      if (_new) {

        this.openModal("modal-container-events");


      } else {

        this.closeModal("modal-container-events");

      }

    }

  }

};
</script>

<style>
.modal-tracking .ui-modal__container {
  width: 90% !important;
}

.pattern-bg {

  background-color: #ffffff;
  background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ededed' fill-opacity='0.28' fill-rule='evenodd'%3E%3Ccircle cx='3' cy='3' r='3'/%3E%3Ccircle cx='13' cy='13' r='3'/%3E%3C/g%3E%3C/svg%3E");
}

.premium-card {
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.10);
}

.route-card {
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.06);
  padding: 18px;
}

.route-bar-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}

.route-track {
  position: relative;
  flex: 1;
  height: 12px;
  background: rgba(220, 53, 69, 0.18); /* rojo suave */
  border-radius: 999px;
  overflow: hidden;
}

.route-fill {
  height: 100%;
  background: #dc3545; /* rojo fuerte */
  border-radius: 999px;
  transition: width .35s ease;
}

.route-dot {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: #dc3545;
  box-shadow: 0 10px 24px rgba(220, 53, 69, 0.18);
}

.eta-box {
  background: rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 16px;
  text-align: center;
}

.eta-date {
  font-size: 34px;
  font-weight: 700;
  letter-spacing: 0.3px;
  color: #111827;
}

.eta-label {
  margin-top: 2px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.55);
}


</style>
